const cache = new Map();
let wasClearedOnce = false;
export const getSvgContent = (url) => {
    const cached = cache.get(url);
    if (cached) {
        return cached;
    }
    const promise = fetch(url)
        .then(response => {
        if (!response.ok) {
            throw new Error(`SvgCache: unable to load SVG ${url}, status: ${response.status}`);
        }
        return response.text();
    })
        .catch(error => {
        cache.delete(url);
        throw error;
    });
    cache.set(url, promise);
    return promise;
};
export const clearSvgCacheOnce = () => {
    if (wasClearedOnce) {
        return;
    }
    wasClearedOnce = true;
    cache.clear();
};
